import {AbstractControl, ValidatorFn} from '@angular/forms';
import {Drawing} from '@domain/production-schedule/drawing';
import {filter, map} from 'lodash-es';

export function uniqueNamesOfAddedDrawingsValidator(drawingsToBeSaved: Drawing[], drawingImageIndex: number): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const name = control.value;
    let result = null;
    const array = filter(drawingsToBeSaved, (value: Drawing, index: number) => index < drawingImageIndex);
    map(array, (value: Drawing) => {
      if (value.name === name) {
        result = {nameInUse: true};
      }
    });

    return result;
  };
}
